import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useEntity, useMeta } from '@uswitch/ev-utils/lib/context/selectors';
import AuthorSnippet from '../components/compounds/author-snippet';
import ExperienceEntitySelector from '../components/modules/experience-entity-selector';
import { EVEntry } from './index';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Fragment as _Fragment } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Url = function Url(_ref) {
  var _author$sys;

  var link = _ref.link,
      variantFlag = _ref.variantFlag,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? [] : _ref$variants,
      _ref$authors = _ref.authors,
      authors = _ref$authors === void 0 ? [] : _ref$authors,
      _ref$editors = _ref.editors,
      editors = _ref$editors === void 0 ? [] : _ref$editors;
  var entity = link || variants[0];
  var author = useEntity(authors[0] || editors[0]);

  var _useMeta = useMeta(['authorSnippet'], {
    useSnippet: false
  }),
      useSnippet = _useMeta.useSnippet;

  return _jsxs(_Fragment, {
    children: [variants.length > 1 ? _jsx(ExperienceEntitySelector, {
      experienceFlag: variantFlag,
      entityList: variants,
      fullPageTest: true
    }) : _jsx(EVEntry, _objectSpread({}, entity)), useSnippet && author !== null && author !== void 0 && (_author$sys = author.sys) !== null && _author$sys !== void 0 && _author$sys.id ? _jsx(AuthorSnippet, _objectSpread({}, author)) : null]
  });
};

export default Url;